export default "__VITE_ASSET__nudKb94J__"